import { render, staticRenderFns } from "./MypageFavoriteTeamLinkSection.vue?vue&type=template&id=ceccb9ce&scoped=true"
import script from "./MypageFavoriteTeamLinkSection.vue?vue&type=script&lang=ts"
export * from "./MypageFavoriteTeamLinkSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageFavoriteTeamLinkSection.vue?vue&type=style&index=0&id=ceccb9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceccb9ce",
  null
  
)

export default component.exports